
    <div class="grid">
        <div class="
                col-12
                sm:col-12
                md:col-6
                lg:col-4
                xl:col-3
                " *ngFor="let item of listProduct">
            <app-custom-product-card [product]="item"></app-custom-product-card>
        </div>
    </div>